// extracted by mini-css-extract-plugin
export var defaultWrapper = "_ni-3";
export var downloadButton = "_ni-4";
export var fileContainer = "_ni-9 _ni-7";
export var fileContainerBase = "_ni-7";
export var fileContainerFixedHeight = "_ni-8 _ni-7";
export var fileInfo = "_ni-5";
export var fileInfoWidthRestricted = "_ni-6";
export var fileType = "_ni-1";
export var fileTypeName = "_ni-2";
export var image = "_ni-0";
export var link = "_ni-b";
export var overflowEllipsis = "_ni-a";